/* Trio TCG theme — interactions. No dependencies. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = matchMedia('(hover:hover)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- header: frosted on scroll + progress hairline ---------- */
  var hdr = $('#hdr');
  function onScroll() {
    if (!hdr) return;
    hdr.classList.toggle('scrolled', scrollY > 20);
    var h = document.documentElement.scrollHeight - innerHeight;
    hdr.style.setProperty('--sp', h > 0 ? (scrollY / h).toFixed(4) : 0);
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- search sheet with live suggestions ---------- */
  var sheet = $('#searchSheet'), sheetQ = $('#sheetQ'), sheetRes = $('#sheetResults'), heroQ = $('#heroQ');
  function openSearch(e) {
    var hq = $('#hq');
    if (hq && !heroQ) { if (e) e.preventDefault(); hq.focus(); scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    if (heroQ) { // on the homepage, use the hero search box
      if (e) e.preventDefault();
      heroQ.focus({ preventScroll: true });
      scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    if (!sheet) return;
    if (e) e.preventDefault();
    sheet.hidden = false; document.body.style.overflow = 'hidden';
    sheetQ.focus(); // inside the tap so iOS raises the keyboard
  }
  function closeSearch() { if (!sheet) return; sheet.hidden = true; document.body.style.overflow = ''; }
  $$('[data-search-open]').forEach(function (a) { a.addEventListener('click', openSearch); });
  if (sheet) {
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSearch(); });
    var st;
    sheetQ.addEventListener('input', function () {
      clearTimeout(st); var q = sheetQ.value.trim();
      if (q.length < 2) { sheetRes.innerHTML = ''; return; }
      st = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { sheetRes.innerHTML = '<p style="color:var(--smoke);text-align:center">No matches yet. Press Search to look everywhere.</p>'; return; }
            sheetRes.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '';
              return '<a class="sr-item" href="' + p.url + '">' + img + '<div><b>' + p.title + '</b><span>$' + p.price + (p.available ? '' : ' · Sold') + '</span></div></a>';
            }).join('') + '<a class="btn btn-line sr-all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
          }).catch(function () {});
      }, 180);
    });
  }
  addEventListener('keydown', function (e) {
    var tag = document.activeElement && document.activeElement.tagName;
    if (e.key === '/' && tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT') { openSearch(e); }
    if (e.key === 'Escape') { closeSearch(); closeFilters(); closeZoom(); }
  });

  /* ---------- live suggestions under the header search pill ---------- */
  var hq = $('#hq'), hsr = $('#hsr');
  if (hq && hsr) {
    var lt;
    var hideHsr = function () { hsr.innerHTML = ''; hsr.classList.remove('open'); };
    hq.addEventListener('input', function () {
      clearTimeout(lt); var q = hq.value.trim();
      if (q.length < 2) { hideHsr(); return; }
      lt = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (hq.value.trim() !== q) return;
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            hsr.innerHTML = '<div class="wrap">' + (items.length ? items.map(function (p) {
              var u = p.featured_image && p.featured_image.url;
              return '<a class="sr-item" href="' + p.url + '">' + (u ? '<img src="' + u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') + '<div><b>' + p.title + '</b><span>$' + p.price + (p.available ? '' : ' · Sold') + '</span></div></a>';
            }).join('') : '<p class="sr-none">No matches yet. Press search to look everywhere.</p>') + '<a class="sr-all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results for “' + q.replace(/</g, '&lt;') + '”</a></div>';
            hsr.classList.add('open');
          }).catch(function () {});
      }, 160);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('#hdr')) hideHsr(); });
    hq.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hideHsr(); hq.blur(); } });
  }

  /* ---------- typed placeholder in the hero search ---------- */
  var typed = $('#typed'), heroForm = $('#heroS');
  if (heroQ && typed) {
    var phrases = (heroQ.getAttribute('data-phrases') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    heroQ.addEventListener('input', function () { heroForm.classList.toggle('has', heroQ.value.length > 0); });
    if (phrases.length && !reduce) {
      heroQ.setAttribute('placeholder', '');
      var pi = 0, ci = 0, del = false;
      (function tick() {
        var p = phrases[pi];
        if (!del) { ci++; if (ci > p.length) { del = true; setTimeout(tick, 1600); return; } }
        else { ci--; if (ci === 0) { del = false; pi = (pi + 1) % phrases.length; } }
        typed.textContent = 'Try "' + p.slice(0, ci) + '"';
        setTimeout(tick, del ? 28 : 62);
      })();
    } else { typed.style.display = 'none'; }
  }

  /* ---------- the binder ---------- */
  /* ---------- binder inside cover: card-of-the-moment spotlight ---------- */
  function initSpotlight(binder, getPage) {
    var root = binder.querySelector('.spot'), dataEl = $('#spotData');
    if (!root || !dataEl) return null;
    var cards = []; try { cards = JSON.parse(dataEl.textContent); } catch (_) {}
    var card = root.querySelector('.spot-card'), img = root.querySelector('.spot-img'), side = root.querySelector('.spot-side');
    var info = root.querySelector('.spot-info'), dotsEl = root.querySelector('.spot-dots');
    if (!cards.length) { root.classList.add('empty'); return null; }
    var HOLD_FRONT = 2800, HOLD_BACK = 1900, i = 0, showingBack = false, busy = false, timer = null, pausedUntil = 0;
    dotsEl.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
    var dots = dotsEl.children;
    function preload(c) { if (!c) return; [c.f, c.b].forEach(function (u) { if (u) { var im = new Image(); im.src = u; } }); }
    function fill(c) {
      root.querySelector('.spot-name').textContent = c.t;
      root.querySelector('.spot-meta').textContent = [c.s, c.n].filter(Boolean).join(' · ');
      root.querySelector('.spot-price').textContent = c.p;
      root.querySelector('.spot-go').setAttribute('href', c.u);
      for (var k = 0; k < dots.length; k++) dots[k].className = '';
      var d = dots[i]; d.style.setProperty('--dur', (HOLD_FRONT + (c.b ? HOLD_BACK : 0) + 700) + 'ms'); void d.offsetWidth; d.className = 'on';
    }
    function turn(src, label, mid, done) {
      if (reduce || !card.animate) { img.src = src; side.textContent = label; if (mid) mid(); if (done) done(); return; }
      busy = true;
      card.animate([{ transform: 'perspective(800px) rotateY(0deg)' }, { transform: 'perspective(800px) rotateY(90deg)' }], { duration: 300, easing: 'cubic-bezier(.55,0,.8,.3)' }).onfinish = function () {
        img.src = src; side.textContent = label; if (mid) mid();
        card.animate([{ transform: 'perspective(800px) rotateY(-90deg)' }, { transform: 'perspective(800px) rotateY(0deg)' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = function () { busy = false; if (done) done(); };
      };
    }
    function schedule(ms) { clearTimeout(timer); timer = setTimeout(step, ms); }
    function live() { return getPage() === 1 && !document.hidden && Date.now() > pausedUntil; }
    function step() {
      if (!live() || busy) { schedule(700); return; }
      var c = cards[i];
      if (!showingBack && c.b) { showingBack = true; turn(c.b, 'Back', null, function () { schedule(HOLD_BACK); }); return; }
      i = (i + 1) % cards.length; showingBack = false;
      var n = cards[i];
      info.classList.add('swap');
      turn(n.f, 'Front', function () { fill(n); info.classList.remove('swap'); preload(cards[(i + 1) % cards.length]); }, function () { schedule(HOLD_FRONT); });
    }
    img.src = cards[0].f; fill(cards[0]); preload(cards[1]);
    schedule(HOLD_FRONT + 1500);
    return {
      manualFlip: function () {
        if (busy) return;
        var c = cards[i]; if (!c.b) { card.animate && card.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 300 }); return; }
        pausedUntil = Date.now() + 6000;
        showingBack = !showingBack;
        turn(showingBack ? c.b : c.f, showingBack ? 'Back' : 'Front', null, function () { schedule(6200); });
      }
    };
  }

  function initBinder() {
    var binder = $('#binder');
    if (!binder || binder.getAttribute('data-ready')) return;
    binder.setAttribute('data-ready', '1');
    var rings = $('.rings', binder), castR = $('#castR'), castL = $('#castL'), dots = $('#dots');
    var D2R = Math.PI / 180;
    var pages = $$('template.binder-page').map(function (t) { return t.innerHTML.trim(); });
    var holes = '<i class="hole" style="top:8.4%"></i><i class="hole" style="top:50%"></i><i class="hole" style="top:91.6%"></i>';
    function buildLeaf(front, back, fCls, bCls, n, curl, extra) {
      var el = document.createElement('div'); el.className = 'leaf' + (extra ? ' ' + extra : '');
      var parent = el, strips = [];
      for (var k = 0; k < n; k++) {
        var s = document.createElement('div'); s.className = 'strip';
        s.style.left = k === 0 ? '0' : '100%'; s.style.width = k === 0 ? (100 / n) + '%' : '100%';
        s.innerHTML = '<div class="face f"><div class="content front ' + fCls + '" style="width:' + (n * 100) + '%;left:-' + (k * 100) + '%">' + front + '</div><div class="sh"></div><div class="gl"></div></div>' +
          '<div class="face b"><div class="content back ' + bCls + '" style="width:' + (n * 100) + '%;left:-' + ((n - 1 - k) * 100) + '%">' + back + '</div><div class="sh"></div><div class="gl"></div></div>';
        parent.appendChild(s); strips.push(s); parent = s;
      }
      return { el: el, strips: strips, n: n, curl: curl, theta: 0, raf: 0 };
    }
    var leaves = [];
    leaves.push(buildLeaf(($('#binderCover') || {}).innerHTML || '', ($('#binderInside') || {}).innerHTML || '', 'leather', 'leather', 1, 0, 'cover'));
    var strips = innerWidth < 760 ? 5 : 7;
    for (var L = 0; L < 2; L++) {
      if (!pages[L * 2] && !pages[L * 2 + 1]) break;
      leaves.push(buildLeaf(holes + (pages[L * 2] || ''), holes + (pages[L * 2 + 1] || ''), 'page', 'page', strips, 26));
    }
    leaves.forEach(function (l) { binder.insertBefore(l.el, rings); });
    var N = leaves.length, page = 0, touched = false, active = null;
    var spot = initSpotlight(binder, function () { return page; });

    function pose(l, theta) {
      l.theta = theta;
      var s = Math.sin(theta * D2R), curl = l.curl * s, rootA = theta - curl, e = l.n > 1 ? 2 * curl / (l.n - 1) : 0;
      for (var k = 0; k < l.n; k++) {
        var rot = k === 0 ? rootA : e, abs = rootA + k * e;
        l.strips[k].style.transform = 'rotateY(' + (-rot) + 'deg)';
        var sa = Math.max(0, Math.sin(abs * D2R)), f = l.strips[k].children[0], b = l.strips[k].children[1];
        f.children[1].style.opacity = (sa * 0.4 * (abs < 90 ? abs / 90 : 1)).toFixed(3);
        b.children[1].style.opacity = (sa * 0.4 * (abs > 90 ? (180 - abs) / 90 : 1)).toFixed(3);
        var gl = k > 0 ? Math.min(0.16, Math.abs(e) * 0.012 * k) : 0;
        f.children[2].style.opacity = gl.toFixed(3); b.children[2].style.opacity = gl.toFixed(3);
      }
      if (l === active) {
        castR.style.opacity = theta < 90 ? Math.sin(theta * D2R).toFixed(3) : '0';
        castL.style.opacity = theta > 90 ? Math.sin(theta * D2R).toFixed(3) : '0';
        castR.style.width = castL.style.width = (50 * (0.35 + 0.65 * Math.abs(Math.cos(theta * D2R)))) + '%';
      }
    }
    function restZ() { leaves.forEach(function (l, i) { if (l !== active) l.el.style.zIndex = (l.theta > 90) ? (i + 1) : (N * 2 - i); }); }
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function animate(l, to, dur, done) {
      cancelAnimationFrame(l.raf); var from = l.theta; if (reduce) dur = 0;
      active = l; l.el.style.zIndex = 200; var t0 = performance.now();
      function step(now) {
        var t = dur ? Math.min(1, (now - t0) / dur) : 1; pose(l, from + (to - from) * ease(t));
        if (t < 1) { l.raf = requestAnimationFrame(step); }
        else { active = null; castR.style.opacity = castL.style.opacity = '0'; restZ(); if (done) done(); }
      }
      l.raf = requestAnimationFrame(step);
    }
    function markDots(p) { $$('button', dots).forEach(function (b, i) { b.setAttribute('aria-current', i === p ? 'true' : 'false'); }); }
    function syncPage() { page = leaves.filter(function (l) { return l.theta > 90; }).length; binder.classList.toggle('closed', page === 0); markDots(page); }
    function go(p) {
      p = Math.max(0, Math.min(N, p));
      var order = []; leaves.forEach(function (l, i) { var want = i < p ? 180 : 0; if (Math.round(l.theta) !== want) order.push([l, want]); });
      if (p < page) order.reverse();
      page = p; binder.classList.toggle('closed', p === 0); markDots(p);
      order.forEach(function (o, j) { setTimeout(function () { animate(o[0], o[1], 1100, syncPage); }, j * 170); });
    }
    for (var d = 0; d <= N; d++) (function (i) {
      var bt = document.createElement('button'); bt.type = 'button';
      bt.setAttribute('aria-label', i === 0 ? 'Cover' : (i === N ? 'Back cover' : 'Spread ' + i));
      bt.onclick = function () { touched = true; go(i); }; dots.appendChild(bt);
    })(d);
    $('#bprev').onclick = function () { touched = true; go(page - 1); };
    $('#bnext').onclick = function () { touched = true; go(page + 1); };
    leaves.forEach(function (l) { pose(l, 0); }); restZ(); syncPage();

    // pockets: a tap opens a preview, a sideways drag turns the page, a vertical swipe just scrolls
    binder.addEventListener('click', function (e) { if (e.target.closest('.pocket')) e.preventDefault(); }, true);
    var peek = $('#peek'), peekCard = $('#peekCard'), peekImg = $('#peekImg'), peekGo = $('#peekGo'), lastPocket = null;
    function openPeek(pocket) {
      if (!peek) { location.href = pocket.getAttribute('href'); return; }
      lastPocket = pocket;
      var thumb = pocket.querySelector('img');
      peekImg.src = pocket.getAttribute('data-img') || (thumb && thumb.src) || '';
      $('#peekTitle').textContent = pocket.getAttribute('data-title') || '';
      $('#peekSet').textContent = pocket.getAttribute('data-set') || '';
      $('#peekPrice').textContent = pocket.getAttribute('data-price') || '';
      peekGo.setAttribute('href', pocket.getAttribute('href'));
      pocket.classList.add('picked');
      peek.hidden = false; document.body.style.overflow = 'hidden';
      var from = (thumb || pocket).getBoundingClientRect(), to = peekCard.getBoundingClientRect();
      if (!reduce && to.width) {
        peekCard.style.transition = 'none';
        peekCard.style.transform = 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ')';
        void peekCard.offsetWidth;
        peekCard.style.transition = '';
        peekCard.style.transform = '';
      }
      requestAnimationFrame(function () { peek.classList.add('on'); });
      setTimeout(function () { peekGo.focus({ preventScroll: true }); }, 50);
    }
    function closePeek() {
      if (!peek || peek.hidden) return;
      peek.classList.remove('on'); peekCard.classList.add('out');
      if (lastPocket) lastPocket.classList.remove('picked');
      setTimeout(function () { peek.hidden = true; peekCard.classList.remove('out'); document.body.style.overflow = ''; }, reduce ? 0 : 260);
    }
    if (peek) {
      $('#peekClose').onclick = closePeek;
      peek.addEventListener('click', function (e) { if (e.target === peek) closePeek(); });
      addEventListener('keydown', function (e) { if (e.key === 'Escape') closePeek(); });
    }
    var drag = null;
    leaves.forEach(function (l, i) {
      l.el.addEventListener('pointerdown', function (e) {
        if (i !== page && i !== page - 1) return;
        touched = true; cancelAnimationFrame(l.raf);
        drag = { l: l, x: e.clientX, y: e.clientY, at: Date.now(), t0: l.theta, moved: false, scroll: false, w: binder.getBoundingClientRect().width, pocket: e.target.closest('.pocket'), flip: e.target.closest('[data-spot-flip]'), go: e.target.closest('.spot-go'), id: e.pointerId, captured: false };
        if (e.pointerType === 'mouse') { drag.captured = true; active = l; l.el.style.zIndex = 200; l.el.classList.add('dragging'); try { l.el.setPointerCapture(e.pointerId); } catch (_) {} }
      });
      l.el.addEventListener('pointermove', function (e) {
        if (!drag || drag.l !== l || drag.scroll) return;
        var dx = drag.x - e.clientX, dy = e.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { drag.scroll = true; return; } // the finger is scrolling the page
          if (Math.abs(dx) <= 8) return;
          drag.moved = true;
          if (!drag.captured) { drag.captured = true; active = l; l.el.style.zIndex = 200; l.el.classList.add('dragging'); try { l.el.setPointerCapture(e.pointerId); } catch (_) {} }
        }
        pose(l, Math.max(0, Math.min(180, drag.t0 + dx / drag.w * 200)));
      });
      function finish(cancelled) {
        if (!drag || drag.l !== l) return; l.el.classList.remove('dragging');
        var d = drag, from = d.t0, th = l.theta, to;
        drag = null;
        if (!d.moved) {
          if (active === l) { active = null; restZ(); }
          if (cancelled || d.scroll) return;                       // scrolling never opens or turns anything
          if (d.pocket && i !== 0 && Date.now() - d.at < 600) { openPeek(d.pocket); return; }
          if (d.go && Date.now() - d.at < 600) { location.href = d.go.getAttribute('href'); return; }
          if (d.flip && Date.now() - d.at < 600) { if (spot) spot.manualFlip(); return; }
          to = from > 90 ? 0 : 180;
        } else {
          to = cancelled ? from : (from < 90 ? (th > 35 ? 180 : 0) : (th < 145 ? 0 : 180));
        }
        animate(l, to, Math.max(380, Math.abs(to - th) / 180 * 1100), syncPage);
      }
      l.el.addEventListener('pointerup', function () { finish(false); });
      l.el.addEventListener('pointercancel', function () { finish(true); });
      l.el.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse' || drag || active || i !== page || i === 0) return; animate(l, 7, 420); });
      l.el.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse' || drag || i !== page || l.theta > 20) return; animate(l, 0, 420); });
    });
    if (canHover && !reduce) binder.addEventListener('pointermove', function (e) {
      var r = binder.getBoundingClientRect();
      binder.style.setProperty('--lx', ((e.clientX - r.left - r.width / 2) / (r.width / 2) * 100) + '%');
      binder.style.setProperty('--ly', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    setTimeout(function () { if (!touched) go(1); }, reduce ? 0 : 1300);
    if (!reduce && N > 2) setInterval(function () { if (!touched && !document.hidden && !active) go(page >= N - 1 ? 1 : page + 1); }, 5800);
  }
  initBinder();

  /* ---------- reviews carousel ---------- */
  function initReviews() { $$('[data-reviews]').forEach(function (sec) {
    if (sec.getAttribute('data-ready')) return; sec.setAttribute('data-ready', '1');
    var row = $('[data-rv-row]', sec), touched = false, timer;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { sec.classList.add('in'); io.disconnect(); } }); }, { threshold: 0.2 });
      io.observe(sec);
    } else sec.classList.add('in');
    if (!row) return;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { row.addEventListener(ev, function () { touched = true; }, { passive: true }); });
    function next() {
      if (touched || document.hidden || !row.isConnected) return;
      var cards = $$('.rv-card', row); if (cards.length < 2) return;
      var pad = parseFloat(getComputedStyle(row).scrollPaddingLeft) || 0, cur = row.scrollLeft, target = null;
      for (var i = 0; i < cards.length; i++) { var x = cards[i].offsetLeft - pad; if (x > cur + 4) { target = x; break; } }
      if (target === null || cur + row.clientWidth >= row.scrollWidth - 4) target = 0;
      row.scrollTo({ left: target, behavior: 'smooth' });
    }
    if (!reduce) timer = setInterval(function () { if (sec.classList.contains('in')) next(); }, 5200);
  }); }
  initReviews();

  /* ---------- language filter on the homepage grid ---------- */
  function initFilters() { $$('[data-filters]').forEach(function (bar) {
    if (bar.getAttribute('data-ready')) return; bar.setAttribute('data-ready', '1');
    var pill = $('.pill', bar), btns = $$('button', bar), grid = bar.closest('section').querySelector('[data-grid]');
    function movePill(b) { if (!pill || !b) return; pill.style.left = b.offsetLeft + 'px'; pill.style.width = b.offsetWidth + 'px'; }
    btns.forEach(function (b) {
      b.onclick = function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); movePill(b);
        var f = b.getAttribute('data-f');
        $$('.pc', grid).forEach(function (c) { c.hidden = !(f === 'all' || c.getAttribute('data-lang') === f); });
      };
    });
    requestAnimationFrame(function () { movePill(btns[0]); });
    addEventListener('resize', function () { movePill($('button[aria-pressed="true"]', bar)); });
  }); }
  initFilters();

  /* ---------- popular cards: chips switch the row ---------- */
  function initPopular() {
    $$('[data-popular]').forEach(function (sec) {
      if (sec.getAttribute('data-ready')) return; sec.setAttribute('data-ready', '1');
      var chips = $$('.pop-chip', sec), rows = $$('[data-pop-row]', sec);
      function show(n) {
        rows.forEach(function (r) { r.hidden = r.getAttribute('data-pop-row') !== String(n); if (!r.hidden) r.scrollLeft = 0; });
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-pop') === String(n) ? 'true' : 'false'); });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () { show(c.getAttribute('aria-pressed') === 'true' ? 0 : c.getAttribute('data-pop')); });
      });
    });
  }
  initPopular();

  /* ---------- Shop by set: find a set ---------- */
  $$('[data-sets]').forEach(function (root) {
    var inp = $('[data-sets-find]', root), none = $('[data-sets-none]', root);
    if (!inp) return;
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase(), any = false;
      $$('[data-sets-group]', root).forEach(function (g) {
        var shown = 0;
        $$('[data-name]', g).forEach(function (el) { var ok = !q || el.getAttribute('data-name').indexOf(q) > -1; el.hidden = !ok; if (ok) shown++; });
        g.hidden = shown === 0; if (shown) any = true;
      });
      if (none) none.hidden = any;
    });
  });

  /* ---------- add to cart without leaving the page ---------- */
  var toast = $('#toast'), tt;
  function showToast(html) { if (!toast) return; toast.innerHTML = html; toast.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 3800); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-add], form.buy')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        if (btn && btn.classList.contains('add')) { btn.classList.add('done'); btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>Added'; }
        else if (btn) { btn.disabled = false; }
        if (navigator.vibrate) try { navigator.vibrate(8); } catch (_) {}
        var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="">' : '';
        showToast(img + '<span>Added to cart</span><a href="' + root + 'cart">View cart</a>');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        showToast('<span>' + ((err && (err.description || err.message)) || 'Couldn\'t add that card. It may have just sold.') + '</span>');
      });
  });

  /* ---------- holo sheen + tilt (mouse only) ---------- */
  function bindHolo(scope) {
    $$('.slab,.pc,.flipcard', scope).forEach(function (el) {
      if (el.dataset.h) return; el.dataset.h = 1;
      var tilt = el.classList.contains('slab');
      el.addEventListener('pointermove', function (e) {
        if (reduce || e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--mx', x * 100 + '%'); el.style.setProperty('--my', y * 100 + '%'); el.style.setProperty('--ang', (90 + x * 60));
        if (tilt) el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 12) + 'deg) rotateY(' + ((x - 0.5) * 14) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { if (tilt) el.style.transform = ''; });
    });
  }
  bindHolo(document);

  /* ---------- cursor-lit hairlines + magnetic buttons (mouse only) ---------- */
  if (canHover && !reduce) {
    var gcs = document.getElementsByClassName('gc'), mx = -9999, my = -9999, gq = false;
    var paint = function () {
      gq = false;
      for (var i = 0; i < gcs.length; i++) {
        var r = gcs[i].getBoundingClientRect(); if (r.bottom < -200 || r.top > innerHeight + 200) continue;
        gcs[i].style.setProperty('--gx', (mx - r.left) + 'px'); gcs[i].style.setProperty('--gy', (my - r.top) + 'px');
      }
    };
    addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; if (!gq) { gq = true; requestAnimationFrame(paint); } }, { passive: true });
    addEventListener('scroll', function () { if (!gq) { gq = true; requestAnimationFrame(paint); } }, { passive: true });
    $$('.btn-chalk').forEach(function (b) {
      if (b.closest('.fapply') || b.classList.contains('big')) return;
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.18) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.3) + 'px)'; });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- numbers count up once ---------- */
  // [data-count] works out its own target from its text: "4.9" -> 4.9, "99.3%" -> 99.3 + "%", "2,000+" -> 2000 + "+"
  $$('[data-count]').forEach(function (el) {
    var m = (el.textContent || '').trim().match(/^([^\d]*)([\d,]*\.?\d+)(.*)$/);
    if (!m) return;
    var num = m[2].replace(/,/g, ''), dec = num.indexOf('.') > -1 ? num.split('.')[1].length : 0;
    el.setAttribute('data-to', num); el.setAttribute('data-dec', dec);
    el.setAttribute('data-pre', m[1]); el.setAttribute('data-suf', m[3]);
    if (m[2].indexOf(',') > -1) el.setAttribute('data-sep', '1');
  });
  if ('IntersectionObserver' in window && !reduce) {
    var fmt = function (v, dec, sep) { return dec ? v.toFixed(dec) : (sep ? Math.round(v).toLocaleString('en-AU') : String(Math.round(v))); };
    var co = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; co.unobserve(en.target);
        var el = en.target, to = parseFloat(el.getAttribute('data-to')), dec = +(el.getAttribute('data-dec') || 0), pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '', sep = el.getAttribute('data-sep') === '1' || !el.hasAttribute('data-count'), t0 = performance.now();
        if (isNaN(to)) return;
        el.textContent = pre + fmt(0, dec, sep) + suf;
        (function st(now) { var t = Math.min(1, (now - t0) / 1600), v = to * (1 - Math.pow(1 - t, 4)); el.textContent = pre + fmt(v, dec, sep) + suf; if (t < 1) requestAnimationFrame(st); })(t0);
      });
    }, { threshold: 0.5 });
    $$('[data-to]').forEach(function (el) { co.observe(el); });
  }

  /* ---------- reveal on scroll (content is visible without it) ---------- */
  var rvs = $$('.rv');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('seen'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rvs.forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('seen'); else io.observe(el); });
  } else rvs.forEach(function (el) { el.classList.add('seen'); });

  /* ---------- iPhone tab bar hides on the way down ---------- */
  var tab = $('#tabbar'), lastY = scrollY;
  if (tab) addEventListener('scroll', function () {
    var y = scrollY, dy = y - lastY;
    if (Math.abs(dy) > 6) { tab.classList.toggle('hide', dy > 0 && y > 420 && document.activeElement.tagName !== 'INPUT'); lastY = y; }
  }, { passive: true });

  /* ---------- collection filters ---------- */
  var panel = $('#filterPanel');
  function closeFilters() { if (panel && panel.classList.contains('open')) { panel.classList.remove('open'); document.body.style.overflow = ''; } }
  $$('[data-filters-open]').forEach(function (b) { b.onclick = function () { panel.classList.add('open'); document.body.style.overflow = 'hidden'; }; });
  $$('[data-filters-close]').forEach(function (b) { if (b.type === 'button') b.onclick = closeFilters; });
  var facet = $('#facetForm');
  if (facet) {
    var narrow = function () { return innerWidth <= 1100; };
    var submitFacets = function () {
      var params = new URLSearchParams(new FormData(facet));
      var sort = $('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
      $$('input', facet).forEach(function (i) { if (i.type === 'number' && !i.value) params.delete(i.name); });
      location.href = facet.getAttribute('action') + '?' + params.toString();
    };
    facet.addEventListener('change', function (e) { if (e.target.type === 'checkbox' && !narrow()) submitFacets(); });
    var pt; facet.addEventListener('input', function (e) { if (e.target.type === 'number' && !narrow()) { clearTimeout(pt); pt = setTimeout(submitFacets, 900); } });
    facet.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
    var sortSel = $('[data-sort]'); if (sortSel) sortSel.addEventListener('change', submitFacets);
  }

  /* ---------- product page: flip, zoom, recommendations ---------- */
  var flip = $('[data-flip]'), flipBtn = $('[data-flip-btn]'), zoom = $('#zoom'), zImg = $('#zoomImg');
  function setFlip(v) { if (!flip) return; flip.setAttribute('aria-pressed', v ? 'true' : 'false'); if (flipBtn) flipBtn.querySelector('span').textContent = v ? 'See the front' : 'See the back'; }
  function openZoom(src) { if (!zoom || !src) return; zImg.src = src; zImg.classList.remove('big'); zoom.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeZoom() { if (zoom && !zoom.hidden) { zoom.hidden = true; document.body.style.overflow = ''; } }
  if (flip) {
    var hasBack = !!$('.fback', flip);
    flip.addEventListener('click', function () { if (hasBack) setFlip(flip.getAttribute('aria-pressed') !== 'true'); else openZoom(zImg.getAttribute('data-front')); });
    if (flipBtn) flipBtn.addEventListener('click', function () { setFlip(flip.getAttribute('aria-pressed') !== 'true'); });
    var zb = $('[data-zoom]'); if (zb) zb.addEventListener('click', function () { openZoom(zImg.getAttribute(flip.getAttribute('aria-pressed') === 'true' ? 'data-back' : 'data-front')); });
    $$('[data-zoom-src]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openZoom(a.getAttribute('href')); }); });
    if (zoom) {
      $('.zclose', zoom).onclick = closeZoom;
      zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
      zImg.addEventListener('click', function (e) {
        var r = zImg.getBoundingClientRect();
        zImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        zImg.classList.toggle('big');
      });
    }
  }
  var recs = $('[data-recs]');
  if (recs && !recs.children.length && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; ro.disconnect();
      fetch(recs.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recs]');
        if (inner && inner.innerHTML.trim()) { recs.innerHTML = inner.innerHTML; bindHolo(recs); }
      }).catch(function () {});
    }, { rootMargin: '400px' });
    ro.observe(recs);
  }
  /* ---------- theme editor: re-run when a section is edited ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initBinder(); initReviews(); initFilters(); initPopular(); bindHolo(e.target);
    $$('.rv', e.target).forEach(function (el) { el.classList.add('seen'); });
  });
})();
